export default "__VITE_ASSET__DFgqzEM7__"